<template>
  <section>
    <div
        class="p-3 rounded border mb-5"
        :class="solution.status === 3 ? 'border-success' : solution.status === 2 ? 'border-warning' : 'border-danger'"
    >
      <div class="form-floating mb-5">
        <textarea
            :disabled="solution.status === 3 || item.checked !== null"
            v-model="solution.comment"
            class="form-control"
            id="floatingTextarea2"
            style="transition: .2s"
            :style="solution.status === 3 ? 'height: 55px' : 'height: 110px'"
        ></textarea>
        <label for="floatingTextarea2">Комментарии</label>
      </div>
      <div class="row mb-5" v-if="item.checked === null">
        <div class="col-4">
          <div class="form-check form-check-custom form-check-success form-check-solid form-check-sm">
            <label @click="solution.status = 3" class="form-check-label cursor-pointer text-primary" for="flexRadioLg1">
              <input
                  class="form-check-input"
                  type="radio"
                  id="flexRadioLg1"
                  :checked="solution.status === 3"
                  name="podft_radio"/>
              Одобрить
            </label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-check form-check-custom form-check-warning form-check-solid form-check-sm">
            <label @click="solution.status = 2" class="form-check-label cursor-pointer text-warning" for="flexRadioLg2">
              <input
                  class="form-check-input"
                  type="radio"
                  :checked="solution.status === 2"
                  id="flexRadioLg2"
                  name="podft_radio"
              />
              Ошибка
            </label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-check form-check-custom form-check-danger form-check-solid form-check-sm">
            <label @click="solution.status = 4" class="form-check-label cursor-pointer text-danger" for="flexRadioLg3">
              <input
                  class="form-check-input"
                  type="radio"
                  :checked="solution.status === 4"
                  id="flexRadioLg3"
                  name="podft_radio"/>
              Отказать
            </label>
          </div>
        </div>
      </div>
      <div class="text-center mb-2" v-else>
        <span class="podft-status" :class="'status-'+item.status" v-html="item.statusName"></span>
      </div>
      <button
          class="btn btn-sm btn-block btn-primary"
          v-if="item.checked === null"
          @click="setPodft"
      >Сохранить</button>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'PodftAsideModalSolution',
    props: {
      solution: null,
      item:     null
    },
    methods: {
      setPodft() {
        this.$emit('setPodft', true)
      }
    }
  }
</script>

<style scoped>

</style>